export const site = {
  name: "Tesla-Verleih-Frankfurt",
  tagline: "Mobilitätsberatung",
  phoneDisplay: "0151 7087 5636",
  phoneTel: "+4915170875636",
  whatsapp: "https://wa.me/4915170875636",
  email: "teslaverleihfrankfurt@gmail.com",
  street: "Kinzigstraße 6",
  city: "63322 Rödermark-Urbach",
  instagram: "https://www.instagram.com/teslaverleihfrankfurt/",
  linkedin: "https://www.linkedin.com/in/juergen-wonner/",
  maps: "https://www.google.com/maps/place/Tesla-Verleih-Frankfurt+Mobilit%C3%A4tsberatung/@49.9669107,8.7893626,533m/data=!3m2!1e3!4b1!4m6!3m5!1s0x47bd6d7294b13f6b:0xb911002c246c7a71!8m2!3d49.9669107!4d8.7919375!16s%2Fg%2F11g1973mnm?authuser=0&entry=ttu",
  mapsEmbed: "https://www.google.com/maps?q=Tesla-Verleih-Frankfurt+Mobilit%C3%A4tsberatung+Kinzigstra%C3%9Fe+6+63322+R%C3%B6dermark&output=embed",
  hours: "Nach Vereinbarung",
};

export const reviews = [
  {
    name: "Markus Huber",
    text: "Absolut empfehlenswerter Service. Von der Kontaktaufnahme bis zur Fahrt: Klasse! Die Kommunikation mit Jürgen lief immer schnell. Die Abwicklung unproblematisch und ungezwungen. Wer vor einer Kaufentscheidung steht, sollte unbedingt vorher mal sich einen Tesla für länger als eine Probefahrt gebucht haben. Ich überlege sogar, das nochmals zu tun. Vielen Dank Jürgen für die super Organisation. Jederzeit wieder!",
  },
  {
    name: "Oliver Laudenbach",
    text: "Ich hatte die Gelegenheit das Tesla Model S für einen Tag zu fahren und es war wirklich eine super Erfahrung. Jürgen hat sich viel Zeit für die Einweisung genommen, war sehr hilfsbereit und gut zu erreichen. Alles in allem sehr zu empfehlen!",
  },
  {
    name: "Ronja W.",
    text: "Die Fahrzeuge sind in einwandfreiem Zustand. Eine unvergleichliche Erfahrung für jeden der unentschlossen ist in Sachen Elektromobilität. Die vergleichbar niedrigen Mietkosten werden nur durch den sehr hohen, sowie qualitativen Service getoppt. Rundum eine super spannende wenn auch exotische Erfahrung – vielleicht weil es einfach zukunftsorientierter ist.",
  },
  {
    name: "Jürgen Homeier",
    text: "Hatte den Tesla S für 3 Tage und bin in der Zeit über 700 km gefahren, einfach mal um ein Gefühl dafür zu bekommen und natürlich auch bei Außentemperaturen von -5 Grad zu testen. Alleine der Support und die Herzlichkeit des Vermieters bringt das schon auf volle 5 Sterne. Er ist immer da für Fragen ob vor, nach oder während des Mietzeitraums. Würde jederzeit wieder einen Tesla bei ihm mieten. Vielen Dank – p.s. der Kaffee ist auch sehr gut :-P",
  },
  {
    name: "S. Becker",
    text: "Sehr nett und sympathisch. Die Kommunikation unkompliziert und schnell. Absolute Empfehlung wenn man mal einen Tesla Probefahren möchte. Das Auto war sehr gepflegt und hatte einen angenehmen Duft. Für die Einweisung wurde sich Zeit genommen. Bezahlung bar oder per PayPal möglich. Vielen Dank und gerne wieder.",
  },
  {
    name: "Carsten F.",
    text: "Wagen war sehr gepflegt von außen wie innen und wie neu. Übergabe, Abholung und Bezahlung war unkompliziert und flexibel. Der Kontakt zum Vermieter war top und sehr nett. Insgesamt absolut empfehlenswert und der Tesla Model 3 fährt sich einfach brutal gut ;)",
  },
  {
    name: "Axel Theobald",
    text: "Dieses Model S einmal zu fahren, war ein Erlebnis, das man kaum beschreiben kann. Man muss es erleben. Diese unglaubliche Kraft, dieses mühelose Fahren wie auf Schienen mit dem Eindruck der vollkommenen Kontrolle über das Fahrzeug. Leider geht so ein Tag auch zu schnell zu Ende, aber es war ein tolles Erlebnis und der nette Vermieter hat das Seine dazu beigetragen. Rundum eine tolle Sache!",
  },
  {
    name: "Osman Göverim",
    text: "Tesla Verleih F. kann ich wärmstens weiterempfehlen. Der Wagen war richtig sauber übergeben worden und mir wurde alles erklärt wie alles funktioniert. Sehr freundlich und nett ohne Zeitdruck. Bin das erste Mal gefahren, war voll überrascht was für eine Kraft da steckt. War nicht das letzte Mal dort. Danke und macht weiter so.",
  },
  {
    name: "Amine Schlegel",
    text: "Schwierig zu entscheiden, was mir mehr Freude bereitet hat: das Auto oder der freundliche & aufgeschlossene Service. Noch schwerer fiel mir nur die Rückgabe nach einer tollen, preiswerten Mietdauer. Vielen Dank für die gemachten Erfahrungen, vielleicht buche ich mir das Model 3 LR noch ein drittes Mal.",
  },
  {
    name: "Falo Reseil",
    text: "Mein erstes Mal Elektrofahrzeug. Ein tolles Auto mit unglaublicher Power. Die Vermietung war sehr einfach. Jürgen steht zu jeder Zeit parat wenn Fragen auftauchen. Alles in allem hervorragend. Danke!",
  },
  {
    name: "Bastian Groh",
    text: "100%ige Empfehlung! Wer hinsichtlich Elektromobilität Fragen hat oder sich bei einer Probefahrt selbst überzeugen möchte, ist hier genau richtig! Vom Erstkontakt, über die Fahrzeugübergabe, bis hin zur Rückgabe wurde alles transparent, verständlich und mit sehr viel Fachwissen sowie Freundlichkeit erläutert und abgewickelt. Ganz klare Empfehlung. Pünktlichkeit, Qualität, Professionalität, Wert.",
  },
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_ev-rental-rheinmain/artifacts/n7fafovs_Bildschirmfoto%202026-07-01%20um%2010.10.13.jpg",
  fleet: "https://customer-assets.emergentagent.com/job_ev-rental-rheinmain/artifacts/qja8ihgb_Bildschirmfoto%202026-07-01%20um%2010.10.06.jpg",
  about: "https://customer-assets.emergentagent.com/job_ev-rental-rheinmain/artifacts/5vt8w4zc_Bildschirmfoto%202026-07-01%20um%2010.10.20.jpg",
};
